import { IMetabaseCardParameter } from './models/metabase.interface';
import { MetabaseCard, MetabaseDataSetQueryTemplateTag } from './models/metabase.model';

export function getTemplateTag(parameter: Partial<IMetabaseCardParameter>, card?: MetabaseCard): MetabaseDataSetQueryTemplateTag | undefined {
  return parameter.slug ? card?.datasetQuery?.native?.templateTags[parameter.slug] : undefined;
}
